import { useMemo, useState } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import styles from "../HistoryDetails.module.scss";
import {
    createDefaultHistoryDocumentUpdateView,
    defaultHistoryDocumentDetailsView,
    defaultHistoryDocumentDownloadView,
} from "./views/defaultHistoryDocumentDetailsView";
import {
    createHistoryDocumentCreateDeleteViewConfig,
    createHistoryDocumentDownloadViewConfig,
    createHistoryDocumentUpdateViewConfig,
} from "./views/historyDocumentDetailsViewConfig";
import {
    HistoryDocumentCreateDeleteDetailsRow,
    HistoryDocumentUpdateDetailsRow,
} from "./utils/historyDocumentDetailsRow";
import { HistoryDocumentDownloadDetailsRow } from "./utils/historyDocumentDownloadRows";

interface HistoryDocumentDownloadDetailsProps {
    data: HistoryDocumentDownloadDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryDocumentDownloadDetails: React.FC<
    HistoryDocumentDownloadDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(defaultHistoryDocumentDownloadView);
    const viewConfig = useMemo(
        () => createHistoryDocumentDownloadViewConfig(),
        [],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No downloads found" />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};

interface HistoryDocumentCreateDeleteDetailsProps {
    data: HistoryDocumentCreateDeleteDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryDocumentCreateDeleteDetails: React.FC<
    HistoryDocumentCreateDeleteDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(defaultHistoryDocumentDetailsView);
    const viewConfig = useMemo(
        () => createHistoryDocumentCreateDeleteViewConfig(),
        [],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No document changes found" />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};

interface HistoryDocumentUpdateDetailsProps {
    data: HistoryDocumentUpdateDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryDocumentUpdateDetails: React.FC<
    HistoryDocumentUpdateDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryDocumentUpdateView(),
    );
    const viewConfig = useMemo(
        () => createHistoryDocumentUpdateViewConfig(data),
        [data],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No document changes found" />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
